module.exports = __webpack_public_path__ + "static/media/t51.a7c7013f.jpg";